import React from "react";
import { Link } from "react-router-dom";
import {
  SCROLL_OFFSET,
  ARTICLE_COLUMN,
  H2,
  BODY,
  STACK_GAP,
  INLINE_LINK,
} from "./sections";

const WhatIsSection = () => {
  return (
    <section
      id="what-is-voice-prompting"
      style={{ scrollMarginTop: `${SCROLL_OFFSET}px` }}
      className={ARTICLE_COLUMN}
    >
      {/* Article intro — sits above the first heading, level with the rail */}
      <p className={BODY}>
        Typing out a good prompt for ChatGPT, Claude, or Gemini takes time,
        especially when the best prompts are detailed, specific, and often
        several sentences long. Voice prompting AI flips that around. Instead of
        typing a paragraph explaining what you want, you say it, the way you
        would explain it to a colleague. This guide covers what voice prompting
        AI is, how to do it well, and how to set it up across the AI tools you
        already use.
      </p>

      <h2 className={`mt-[40px] md:mt-[48px] ${H2}`}>
        What Is Voice Prompting AI?
      </h2>

      <p className={`${STACK_GAP} ${BODY}`}>
        Voice prompting AI is the practice of speaking a prompt out loud instead
        of typing it, using speech to text software to convert what you say into
        text that gets sent to an AI chatbot. It is a natural fit for AI tools
        because the best prompts tend to be longer and more conversational than
        a typical search query. You are not typing two or three keywords. You
        are describing context, constraints, and what you want the output to
        look like.
      </p>

      <p className={`${STACK_GAP} ${BODY}`}>
        If you are curious about what happens between speaking and the text
        landing in the chat box, this breakdown of{" "}
        <Link to="/how-ai-voice-typing-works" className={INLINE_LINK}>
          how AI voice typing works
        </Link>{" "}
        covers the speech recognition and cleanup steps in more detail.
      </p>

      <p className={`${STACK_GAP} ${BODY}`}>
        Speaking a prompt is closer to how most people naturally explain a
        problem than typing is. That is part of why voice prompted requests to
        AI tools often come out more detailed and more specific. It is easier to
        keep talking through the nuance of what you want than to keep typing it.
      </p>
    </section>
  );
};

export default WhatIsSection;
